interface Props {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export function Pagination({ page, totalPages, onChange }: Props) {
  if (totalPages <= 1) return null;
  return (
    <div className="pagination">
      <button className="secondary" onClick={() => onChange(page - 1)} disabled={page <= 1}>
        ← Précédent
      </button>
      <span className="muted">Page {page} / {totalPages}</span>
      <button className="secondary" onClick={() => onChange(page + 1)} disabled={page >= totalPages}>
        Suivant →
      </button>
    </div>
  );
}
